/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Memory_Add_PlaceholderInputs */



/**
* | output |
* | --- |
* | "e.g. Answer in German, short bullet points" |
*
* @param {Memory_Add_PlaceholderInputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
export const memory_add_placeholder = /** @type {((inputs?: Memory_Add_PlaceholderInputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Memory_Add_PlaceholderInputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "de") return /** @type {LocalizedString} */ ("z. B. Antworte auf Deutsch, kurze Stichpunkte")
	return /** @type {LocalizedString} */ ("e.g. Answer in German, short bullet points")
});